<template>
<div>
    <vue-snotify></vue-snotify>
    <div class="card noPadding" v-for="(dato,index) in datos" :key="dato.key">
        <div class="card-content">
            <div class="container">
                <div class="row">
                    <div class="col-auto content-col">
                        <font-awesome-icon :icon="dato.icon" style="color:#00B99E"/>
                    </div>
                    <div class="col content-col">
                        <div class="input-field">
                            <input :type="dato.type" :class=" dato.edit " v-model="item[dato.key]" v-bind:readonly="dato.readOnly"> <!--poner clase "edit" para editar campo y remover readonly -->
                        </div>
                    </div>
                    <div class="col-auto content-col">
                        <button class="paragraph touchpad" @click="edit(index,dato.key)" :ref="'label_'+dato.key">{{dato.label}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-auto content-col col-save-user" >
        <button class="button button-save-user" @click="updateUser">
            <span>Guardar</span>
        </button>
    </div>    
</div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPhoneAlt, faEnvelope,faUser, faUserTag, faMobileAlt} from '@fortawesome/free-solid-svg-icons'
library.add(faPhoneAlt)
library.add(faEnvelope)
library.add(faUser)
library.add(faUserTag)
library.add(faMobileAlt)

export default {
    name: 'perifl',
    props:['item'],
    data () {
        return{
            isLoading:false,
            url: this.$store.getters.getMainUrl,
            providerID:this.$store.state.userInfo.net,
            datos:[
                {
                    icon:'user',
                    key:'nombre',
                    readOnly:true,
                    edit:'',
                    label:'Editar',
                    type:'text',
                    
                },
                {
                    icon:'user-tag',
                    key:'nickname',
                    readOnly:true,
                    edit:'',
                    label:'Editar',
                    type:'text',
                    
                },
                {
                    icon:'phone-alt',
                    key:'telefono',
                    readOnly:true,
                    edit:'',
                    label:'Editar',
                    type:'number',
                    maxlength:10
                },
                {
                    icon:'envelope',
                    key:'email',
                    readOnly:true,
                    edit:'',
                    label:'Editar',
                    type:'email',
                    
                },
                {
                    icon:'mobile-alt',
                    key:'celular',
                    readOnly:true,
                    edit:'',
                    label:'Editar',
                    type:'number',
                    maxlength:10
                }
            ]
        }
    },
    computed:{
    token(){
      return this.$store.getters.getToken;
    }
    },
    methods:{
        getValue(key){
            return this.item[key];
        },
        edit(index,key){
            if(this.datos[index].readOnly){
                this.datos[index].readOnly = false;
                this.datos[index].edit = 'edit';
                this.datos[index].label = 'Aceptar';
            }else{
                this.datos[index].readOnly = true;
                this.datos[index].edit = '';
                this.datos[index].label = 'Editar';
            }
        },
        updateUser(){
            this.isLoading = true;
            var post_data = {
                cmd: "updateInfoUser",
                data: {
                    token: this.token,
                    providerID: this.providerID,
                    user:this.item
                }
            };
            if(this.item.imagen){
                if(this.item.imagen.includes('https://')){
                    delete this.item.imagen
                }
            }
            if(this.item.banner){
                if(this.item.banner.includes('https://')){
                    delete this.item.banner
                }
            }
            var self = this;
            axios.post(this.url+'UsersBdtr', JSON.stringify(post_data)) //petición
            .then((response)=>{
                self.isLoading = false;
                if(response.data.success){
                    self.$emit('updateItem',response.data.data);
                    self.success('Usuario Actualizado');
                }else{
                    console.log(response.data.error)
                    self.error(response.data.error);
                }
            })
            .catch(function (error) {
                var response = {success:false,error:error}
                console.log(error);
            });
        },
        success(msg){
            this.$snotify.success(msg, 'Success');
        },
        error(msg){
            this.$snotify.error(msg, 'Error');
        },
        
    },
    directives: {
    'number-only': {
      bind(el, binding) {
        // Agregar un manejador de eventos al elemento
        el.addEventListener('keydown', (event) => {
            console.log(event.keyCode);
          // Obtener el valor actual del elemento
          let value = el.value
          // Obtener el código de la tecla presionada
          let keyCode = event.keyCode
          // Permitir solo números y teclas de control (backspace, delete, etc.)
          if (!/\d/.test(event.key) && keyCode !== 8 && keyCode !== 46 && keyCode !== 37 && keyCode !== 39) {
            event.preventDefault()
          }
          // Limitar la longitud del valor a la cantidad especificada en la directiva
          if (value.length >= binding.value && keyCode !== 8 && keyCode !== 46) {
            event.preventDefault()
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.col-save-user{
    text-align:center;
}
.button-save-user{
    background: #00b99e;
    color:#FFF;
}
.button-save-user:hover{
    background: #EBF9FF;
    color:#062633;
}

</style>
